module.exports = __webpack_public_path__ + "static/media/jo.97f77f12.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/jo.svg
// module id = 2125
// module chunks = 0